import { defineMessages } from 'react-intl';

export default defineMessages({
  proposalDetails: 'Proposal details',

  state: 'State',
  aip: 'AIP number',
  requires: 'Required AIPs',
  quorum: 'Quorum',
  participatingAdresses: 'Participating adresses',
  totalPossibleVotes: 'Total voting power',
  voteDifferential: 'Vote differential needed',
  currentVoteDifferential: 'Current differential',
  author: 'Author',
  discussions: 'Discussions',

  showPayload: 'Show payload',
  showTopAddresses: 'Show top 10 addresses',
  view: 'View',

  created: 'Created',
  starting: 'Starting',
  execution: 'Execution (max)',
  executed: 'Executed',
  failed: 'Failed',
  block: 'Block',
});
